// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"105c275b","487":"27c40c09"}[chunkId] + ".chunk.css";
};